import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import fordStyles from "../dashboardCards/DashboardCards-Ford.module.scss";
import lincolnStyles from "../dashboardCards/DashboardCards-Lincoln.module.scss";
import { IS_FORD_BRAND, IS_CANADA_MARKET } from "../../../utils/EmpUtil";
import { messages } from "./messages";
import { Box } from "@mui/material";

const DashboardMessage = (props) => {
  const { user, userDetails, t } = props;
  const styles = IS_FORD_BRAND(user.brand) ? fordStyles : lincolnStyles;
  const brand = IS_FORD_BRAND(user.brand) ? "FordBrand" : "LincolnBrand";
  const market = IS_CANADA_MARKET(user.market) ? "CA" : "US";
  const roles = userDetails?.roles || [];
  const permissionsMap = new Map();

  // universal messages
  permissionsMap.set("FIELD_VIEW", messages.FIELD_User_Message);
  permissionsMap.set(
    "EMP_ECOMM_ACCESSORIES",
    messages[`${market}_${brand}_AccessoriesMessage`]
  );
  permissionsMap.set(
    "EMP_ECOMM_ACCESSORIES,EMP_ECOMM_CUSTOMERHANDLING,EMP_ECOMM_DEALER,SUBMIT",
    messages.ECOMM_AllPermissions_Message
  );
  permissionsMap.set(
    "EMP_ECOMM_ACCESSORIES,EMP_ECOMM_CUSTOMERHANDLING,EMP_ECOMM_DEALER,SUBMIT,VIEW",
    messages.ECOMM_AllPermissions_Message
  );

  permissionsMap.set(
    "EMP_ECOMM_ACCESSORIES,EMP_ECOMM_CUSTOMERHANDLING,EMP_ECOMM_DEALER,EMP_MODELE,SUBMIT",
    messages.ECOMM_AllPermissions_Message
  );

  permissionsMap.set(
    "EMP_ECOMM_ACCESSORIES,EMP_ECOMM_CUSTOMERHANDLING,EMP_ECOMM_DEALER,EMP_MODELE,SUBMIT,VIEW",
    messages.ECOMM_AllPermissions_Message
  );

  // brand and market specific messages
  permissionsMap.set("VIEW", messages[`${market}_${brand}_ViewMessage`]);
  permissionsMap.set("SUBMIT", messages[`${market}_${brand}_SubmitMessage`]);
  permissionsMap.set(
    "SUBMIT,VIEW",
    messages[`${market}_${brand}_SubmitMessage`]
  );
  permissionsMap.set(
    "EMP_ECOMM_ACCESSORIES,SUBMIT",
    messages[`${market}_${brand}_SubmitMessage`]
  );
  permissionsMap.set(
    "EMP_ECOMM_ACCESSORIES,SUBMIT,VIEW",
    messages[`${market}_${brand}_SubmitMessage`]
  );
  permissionsMap.set(
    "EMP_ECOMM_CUSTOMERHANDLING,MANAGE_ORDER_BANK,VIEW",
    messages[`${market}_${brand}_CustomerHandlingMessage`]
  );
  permissionsMap.set(
    "EMP_ECOMM_ACCESSORIES,EMP_ECOMM_CUSTOMERHANDLING",
    messages[`${market}_${brand}_CustomerHandlingAndAccessoryMessage`]
  );
  permissionsMap.set(
    "EMP_ECOMM_ACCESSORIES,EMP_ECOMM_CUSTOMERHANDLING,MANAGE_ORDER_BANK,VIEW",
    messages[`${market}_${brand}_CustomerHandlingAndAccessoryMessage`]
  );
  permissionsMap.set(
    "EMP_DLR_PRNCPL",
    messages.ECOMM_CA_DealerPrincipal_Message
  );
  permissionsMap.set(
    "EMP_DLR_PRNCPL,SUBMIT",
    messages.ECOMM_AllPermissions_Message
  );
  permissionsMap.set(
    "EMP_DLR_PRNCPL,VIEW",
    messages.ECOMM_AllPermissions_Message
  );
  permissionsMap.set(
    "EMP_DLR_PRNCPL,SUBMIT,VIEW",
    messages.ECOMM_AllPermissions_Message
  );
  permissionsMap.set("EMP_MODELE", messages.ECOMM_MODELE_Message);
  permissionsMap.set("EMP_ADMIN", messages.ECOMM_Admin_Message);
  permissionsMap.set("EMP_CRC,EMP_CRC_REFUND", messages.ECOMM_CRC_Message);
  permissionsMap.set("EMP_CRC", messages.ECOMM_CRC_Message);

  // convert translation strings into returned HTML with criteria
  const processStrings = (translationArr) => {
    return translationArr.map((string) =>
      string === "DealerDashboard.navBarTextIntro" ||
      string === "DealerDashboard.navBarText_additionalPermissions" ||
      string === "DealerDashboard.eComm_Accessory_navBarText" ||
      string === "DealerDashboard.allPermissions" ||
      string === "DealerDashboard.fieldViewUserNavBarText" ||
      string === "DealerDashboard.modelEPilot" ? (
        <li className={styles.unstyledListItem} key={string}>
          {t(string)}
        </li>
      ) : (
        <li key={string}>{t(string)}</li>
      )
    );
  };

  // check user roles, if all exist process translation strings
  const checkPermissions = (permissionsArr, translationArr) => {
    if (translationArr === undefined) {
      return "";
    }

    const arrayCheck = permissionsArr.every((value) => roles.includes(value));

    return arrayCheck ? processStrings(translationArr) : null;
  };

  const sortedRolesKey = [...roles]
    .sort((roleA, roleB) => {
      if (roleA > roleB) {
        return 1;
      }

      if (roleA < roleB) {
        return -1;
      }

      return 0;
    })
    .join(",");

  return (
    <Box mb={0} component="ul" className={styles.styledList}>
      {checkPermissions(roles, permissionsMap.get(sortedRolesKey))}
    </Box>
  );
};

DashboardMessage.propTypes = {
  user: PropTypes.shape({
    brand: PropTypes.string,
    market: PropTypes.string,
  }).isRequired,
  userDetails: PropTypes.shape({
    roles: PropTypes.arrayOf(PropTypes.string),
  }),
  t: PropTypes.func.isRequired,
};

DashboardMessage.defaultProps = {
  userDetails: {
    roles: [],
  },
};

export default withTranslation("emp")(DashboardMessage);
